import { Button } from 'components/Button'
import { Modal } from '../_UI'
import { useWatch } from 'react-hook-form'
import { Input, Radios } from 'components/Form'
import { HOTJAR_CLASSNAME } from 'utils/constants'

interface ModalRecommendationProps {
  open: boolean
  onClose: () => void
  onReviewCurriculum: () => void
  onApplyVacancy: () => void
}

export const ModalRecommendation = ({
  open,
  onClose,
  onReviewCurriculum,
  onApplyVacancy
}: ModalRecommendationProps) => {
  const inputIsConfirmed = useWatch({ name: 'isConfirmed' })
  const isConfirmed = inputIsConfirmed === 'sim'

  return (
    <Modal
      size="800px"
      open={open}
      onClose={onClose}
      className={`flex flex-col w-full ${HOTJAR_CLASSNAME}`}
    >
      <form
        onSubmit={event => event.preventDefault()}
        className="s-form flex-1 flex flex-col gap-y-4"
      >
        <p className="text-sm font-semibold">Você possui indicação?</p>

        <Radios
          name="isConfirmed"
          options={[
            { text: 'Não', value: 'nao' },
            { text: 'Sim', value: 'sim' }
          ]}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <Input
            name="name"
            label="Nome"
            placeholder="Nome do responsável pela indicação"
            required={isConfirmed}
            disabled={!isConfirmed}
          />
          <Input
            name="email"
            label="E-mail"
            placeholder="E-mail do responsável pela indicação"
            required={isConfirmed}
            disabled={!isConfirmed}
          />
        </div>

        <div className="mt-6 w-full grid grid-cols-1 md:grid-cols-2 gap-4">
          <Button
            onClick={onReviewCurriculum}
            className="py-3 bg-transparent text-primary !border !border-primary"
          >
            Revisar
          </Button>
          <Button className="py-3" onClick={onApplyVacancy}>
            Efetuar candidatura
          </Button>
        </div>
      </form>
    </Modal>
  )
}
